import React from 'react'
import style from './font-size-10.module.scss'

interface IProps {
  width?: number
  height?: number
  className?: string
}

const FontSize10: React.FC<IProps> = ({
  width,
  height,
  className,
  children,
}) => {
  return (
    <React.Fragment>
      <span
        className={`${style['wrapper']} ${className}`}
        style={{ width, height }}
      >
        <span className={style['inner']}>{children}</span>
      </span>
    </React.Fragment>
  )
}

export default FontSize10
